import { CONFIGURATION_FLAGS } from './configurationFlags';

export default defineAppConfig({
  clientHomePage: 'https://caravelo.com',

  features: CONFIGURATION_FLAGS,

  travelType: {
    icon: 'airplane',
    iconInactive: 'airplanemode-inactive',
  },

  appearance: {},
});
